<script>
import { PRINT_INFO } from '../../../graphql/queries/UserQueries'
import myUserData from '../../../mixins/myUserData'

export default {
  name: 'PrintHeader',
  mixins: [myUserData],
  props: {
    reports: {
      default: () => [],
      type: Array,
      required: false
    }
  },
  computed: {
    lastTestDate() {
      return this.reports && this.reports.length
        ? new Date(
            Math.max.apply(
              null,
              this.reports.map(
                e =>
                  new Date(
                    Math.max.apply(null, e.results.map(f => new Date(f.date)))
                  )
              )
            )
          )
        : null
    }
  }
}
</script>

<template>
  <div v-if="_user" class="print-header is-shown-print">
    <h1 class="title is-3">
      {{ _user.firstName + ' ' + _user.lastName }}
    </h1>
    <p class="subtitle">
      <span class="has-text-primary">Date of birth:</span>
      {{ _user.birthDate | moment('YYYY-MM-DD') }}
      <br />
      <span v-if="lastTestDate">
        <span class="has-text-primary">Last test date:</span>
        {{ lastTestDate | moment('YYYY-MM-DD') }}
      </span>
    </p>
    <hr class="spacer" />
  </div>
</template>
